import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CalanderPage } from './calander';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    CalanderPage,
  ],
  imports: [
    IonicPageModule.forChild(CalanderPage),PipesModule
  ],
  entryComponents: [
    CalanderPage
  ]
})
export class CalanderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/calander/calander.module.ts